import { formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  // { accessorKey: "category_key", header: "Key" },
  { accessorKey: "category_name", header: "Name" },
  { accessorKey: "total_products", header: "Total Products" },
  { accessorKey: "total_quantity_sold", header: "Quantity Sold" },
  {
    accessorKey: "total_sales",
    header: "Total Sales",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.total_sales)}`,
  },
]
